import type { LegacyMetricsStat, LegacyMetricsSummary } from "./legacyMetrics.types";

/** The values shown in the Figma "Legacy Metrics Home" frame. */
const FIGMA_TOP_LEVEL_STATS: readonly LegacyMetricsStat[] = [
  { key: "searches", label: "Searches", value: "1,300,512", caption: "in the last 30d" },
  {
    key: "delivery-failure-rate",
    label: "Delivery Failure Rate",
    value: "5.3%",
    caption: "427M total",
  },
  { key: "partners-in-breach", label: "Partners in Contract Breach", value: "2" },
  { key: "highest-usage-partner", label: "Partner with the Highest Usage", value: "Alpha" },
  { key: "media-plays", label: "Media Plays", value: "46,300" },
];

/** A valid sample summary (the Figma values), with any overrides applied last. */
export function makeLegacyMetricsSummary(
  overrides: Partial<LegacyMetricsSummary> = {}
): LegacyMetricsSummary {
  return { isSample: true, topLevelStats: FIGMA_TOP_LEVEL_STATS, ...overrides };
}
